import { Injectable } from '@angular/core';
import { JSONRPCService } from '@s8l/client-tree-lib';

import { serviceURL } from './service';

export enum AggregationGroup {
  roles = 'roles', // array	user roles array from metadata	user, event
  licences = 'licences', // string	the users licence	user, event
  feature = 'feature', // string	app feature identifier	event	menu, quiz, flashcard, ...
  path_segment_0 = 'path_segment_0', // path segment at index 0: root node
  path_segment_1 = 'path_segment_1', // path segment at index 1: base/module/branch segment
  path_segment_2 = 'path_segment_2', // path segment at index 2: module or submodule segment
  path_segment_3 = 'path_segment_3', // path segment at index 3
  path_segment_4 = 'path_segment_4', // path segment at index 4
  path = 'path', // string	path of a time event
  page = 'page', // string	page of a time event
  event = 'event', // string	event type	event	open, flip, play, ...
  date = 'date', // string	yyyy-MM-dd	event	used to group by days
  year = 'year', // string	yyyy - year	event	string, but parsable as int
  month = 'month', // string	MM - month of the year	event	string, but parsable as int
  week = 'week', // string	ww - week of the year	event	string, but parsable as int
  day = 'day', // string	dd - day of the month	event	string, but parsable as int
  hour = 'hour' // string	hh - hour of the day	event	string, but parsable as int
}

export interface Statsrequest {
  groupBy: AggregationGroup[];
  filter?: { [index in AggregationGroup]: any };
  exclude?: { [index in AggregationGroup]: any };
}

export interface Bounds extends Statsrequest {
  from?: Date;
  to?: Date;
}

export interface AccessFilter {
  uuid?: string;
  name?: string;
  labels?: { [index in string]: string };
  meta?: {
    roles?: string[];
    users?: string[];
  };
}

export interface UserLabel {
  key?: string;
  values?: string[];
}

@Injectable({
  providedIn: 'root'
})
export class StatsServerService extends JSONRPCService {
  public times(params: Bounds): Promise<any> {
    return this.message(serviceURL('STATS_SERVER', '/metric'), 'times', params);
  }

  public activeUsers(params: Bounds): Promise<any> {
    return this.message(serviceURL('STATS_SERVER', '/metric'), 'active_users', params);
  }

  public users(params: Statsrequest): Promise<any> {
    return this.message(serviceURL('STATS_SERVER', '/metric'), 'users', params);
  }

  public mediaPlays(params: Bounds): Promise<any> {
    return this.message(serviceURL('STATS_SERVER', '/metric'), 'media_plays', params);
  }

  public gamesPlayed(params: Bounds): Promise<any> {
    return this.message(serviceURL('STATS_SERVER', '/metric'), 'games_played', params);
  }

  public transition(params: Bounds): Promise<any> {
    return this.message(serviceURL('STATS_SERVER', '/metric'), 'transition', params);
  }

  public sessionTimes(params: Bounds): Promise<any> {
    return this.message(serviceURL('STATS_SERVER', '/metric'), 'session_times', params);
  }

  public activeThreshold(params: Bounds): Promise<any> {
    return this.message(serviceURL('STATS_SERVER', '/metric'), 'active_threshold', params);
  }

  public adminFilterCreate(params: AccessFilter): Promise<AccessFilter> {
    return this.message(serviceURL('STATS_SERVER', '/admin/access/filter'), 'create', params);
  }

  public adminFilterUpdate(params: AccessFilter): Promise<AccessFilter> {
    return this.message(serviceURL('STATS_SERVER', '/admin/access/filter'), 'update', params);
  }

  public adminFilterDelete(uuid: string): Promise<any> {
    return this.message(serviceURL('STATS_SERVER', '/admin/access/filter'), 'delete', { uuid });
  }

  public adminFilterList(): Promise<AccessFilter[]> {
    return this.message(serviceURL('STATS_SERVER', '/admin/access/filter'), 'list', {});
  }

  public adminLabelList(): Promise<UserLabel[]> {
    return this.message(serviceURL('STATS_SERVER', '/admin/label'), 'list', {});
  }
}
